import styled from 'styled-components';

const ItemDiv = styled.div`
  min-width: 168px;
  width: 100%;
`;
export { ItemDiv };
